import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, ReplaySubject, tap } from "rxjs";
import { environment } from "@env/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ExternalUser } from "./external-user.interface";

@Injectable()
export class ExternalUserService {

    baseUrl = environment.auth_url + '/admin/external-users';
    private _externalUser: ReplaySubject<ExternalUser> = new ReplaySubject<ExternalUser>(1);
    private _externalUsers: BehaviorSubject<ExternalUser[]> = new BehaviorSubject<ExternalUser[]>([]);
    private _metadata: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    set externalUser(value: ExternalUser) {
        this._externalUser.next(value);
    }

    get externalUser$() {
        return this._externalUser.asObservable();
    }

    set externalUsers(value: ExternalUser[]) {
        this._externalUsers.next(value);
    }

    get externalUsers$() {
        return this._externalUsers.asObservable();
    }

    get metadata$(): Observable<any> {
        return this._metadata.asObservable();
    }

    constructor(
        private _httpClient: HttpClient
    ) { }

    search(filters?: { page?: number; size?: number; keyword?: string; externalEntityType?: string; enabled?: boolean }): Observable<any> {
        let params = new HttpParams();
        if (filters) {
            if (filters.page !== undefined) params = params.set('page', filters.page.toString());
            if (filters.size !== undefined) params = params.set('size', filters.size.toString());
            if (filters.keyword) params = params.set('keyword', filters.keyword);
            if (filters.externalEntityType) params = params.set('externalEntityType', filters.externalEntityType);
            if (filters.enabled !== undefined) params = params.set('enabled', filters.enabled.toString());
        }
        return this._httpClient.get<any>(`${this.baseUrl}`, { params })
        .pipe(
            tap((response: any) => {
                this._externalUsers.next(response?.content || []);
                this._metadata.next(response);
            }),
            catchError(() => of({ content: [] }))
        );
    }

    getByUuid(uuid: string): Observable<ExternalUser> {
        return this._httpClient.get<ExternalUser>(`${this.baseUrl}/${uuid}`)
        .pipe(
            tap((user) => {
                this.externalUser = user;
                return user;
            }),
            catchError(() => of({} as ExternalUser))
        );
    }

    activate(uuid: string): Observable<ExternalUser> {
        return this._httpClient.put<ExternalUser>(`${this.baseUrl}/${uuid}/activate`, {})
        .pipe(
            tap((user) => {
                this.externalUser = user;
                return user;
            }),
            catchError(() => of({} as ExternalUser))
        );
    }

    deactivate(uuid: string): Observable<ExternalUser> {
        return this._httpClient.put<ExternalUser>(`${this.baseUrl}/${uuid}/deactivate`, {})
        .pipe(
            tap((user) => {
                this.externalUser = user;
                return user;
            }),
            catchError(() => of({} as ExternalUser))
        );
    }
}
